import { RangeSlider } from '../../Form/RangeSlider/index.tsx';
import { type Props } from './types.ts';

export const CertificationRangeSlider = ({
  ariaLabelledBy,
  certifications,
  disabled,
  name,
  onChange,
  value,
}: Props) => {
  const max = certifications.length;
  const formatValueLabel = (val: number) => certifications.find(entry => entry.value === val)?.label;

  const formatAriaValueText = (val: number) =>
    `${String(certifications.find(entry => entry.value === val)?.label)} certification`;

  const handleOnChange = (event: Event, val: number | number[], activeThumb: number) => {
    onChange(event, val, activeThumb);
  };

  return (
    <RangeSlider
      ariaLabelledBy={ariaLabelledBy}
      disabled={disabled}
      formatAriaValueText={formatAriaValueText}
      formatValueLabel={formatValueLabel}
      getAriaLabel={() => 'Select certification range'}
      marks={certifications}
      max={max}
      min={1}
      name={name}
      onChange={handleOnChange}
      step={1}
      sx={{
        '.MuiSlider-markLabel': {
          color: theme => theme.palette.grey[400],
        },
        '.MuiSlider-markLabelActive': {
          color: theme => theme.palette.grey[100],
        },
        marginLeft: theme => theme.spacing(1),
        width: theme => `calc(100% - ${theme.spacing(2)})`,
      }}
      value={value}
    />
  );
};
